import { t } from 'i18next';

export const surveyConfigTabs = {
  customerTypes: {
    key: 'customer-types',
    label: t('surveys.configuration.customerTypes'),
  },
  jobTypes: {
    key: 'job-types',
    label: t('surveys.configuration.jobTypes'),
  },
  unplannedServiceTypes: {
    key: 'unplanned-service-types',
    label: t('surveys.configuration.unplannedServiceTypes'),
  },
};
